<div class="emoji-picker" (click)="$event.stopPropagation()">
  <div class="header">
    <div class="search-wrapper">
      <andor-text-input [control]="searchFormControl" mode="flat" [showAction]="true">
        <div class="reset" (click)="reset()">
          <fa-icon [icon]="faRotateBackward"></fa-icon>
        </div>
      </andor-text-input>
    </div>
  </div>
  @let categories = filteredEmojis();
  <div class="content-container">
    <div class="content" #emojiContent>
      @for (category of categories; track category.name) {
        <div class="category {{ category.name }}">
          @for (emoji of category.emojis; track emoji[0]) {
            <div class="emoji" (click)="selectedEmoji.emit(emoji[0])">
              {{ emoji[0] }}
            </div>
          }
        </div>
      }
    </div>
    <div class="categories">
      @for (category of categories; track category.name) {
        <div class="category" (click)="selectCategory(category.name, emojiContent)">
          {{ category.icon[0] }}
        </div>
      }
    </div>
  </div>
</div>
